import type { DeclaredFieldPayload } from '@Application/Documents/TemplateFiles/Actions/documentTemplateFileDescribed';
import type LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `payload.type` is the library's raw field type string, not yet an object: `resolveFieldType` turns
 * it into a `LabeledValueView`, falling back to the raw value as its own label when the caller's
 * catalogue (`templateFieldTypesStore`) has no matching entry.
 */
class DocumentTemplateFilePreviewFieldView {
	readonly uuid: string;
	readonly path: string;
	readonly label: string;
	readonly type: LabeledValueView;
	readonly isRequired: boolean;
	readonly order: number;

	constructor(payload: DeclaredFieldPayload, resolveFieldType: (value: string) => LabeledValueView) {
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.label = payload.label;
		this.type = resolveFieldType(payload.type);
		this.isRequired = payload.isRequired;
		this.order = payload.order;

		Object.freeze(this);
	}
}

export default DocumentTemplateFilePreviewFieldView;
